 <template>
    <section class="settings">
      <div class="panel">
        <div class="panel-heading"><h2>Account<i class="clippie fa fa-info-circle" v-tooltip="'Update your avatar, add your title and adjust notification settings'"></i></h2></div>
      
        <div class="panel-body" v-if="person">
            <div class="col-sm-12 col-md-3 text-center">
                <img v-bind:src="person.avatar" class="avatar">
                <label class="btn btn-success avatar-button" for="avatar">
                    <span v-if="localStorage.roles.includes('Mentor')">
                        Change Profile Picture
                    </span>
                    <span v-else>
                        Change Avatar
                    </span>
                </label>
                <input class="form-control" ref="avatar" type="file" name="avatar" @change="setAvatar" id="avatar">
            </div>
            <div class="col-sm-12 col-md-9">

                <h3>General Information</h3>
                <table class="table">
                    <tbody>
                        <tr>
                            <td>Name</td><td>{{person.firstName}} {{person.lastName}}</td>

                        </tr>
                        <tr v-if="!roles.includes('Recruiter') && !roles.includes('GlobalMentor')">
                            <td>Title</td><td><input class="form-control" type="text" v-model="person.title"></td>
                        </tr>
                    </tbody>
                </table>
                <table class="table">
                    <tbody>
                        <tr>
                            <td>ID Number</td><td>{{person.populiId}}</td>
                        </tr>
                        <tr>
                            <td>Address</td><td><input class="form-control" type="text" v-model="person.address"></td>
                        </tr>
                        <tr>
                            <td>City</td><td><input class="form-control" type="text" v-model="person.city"></td>
                        </tr>
                        <tr>
                            <td>State / Province</td>
                            <td>
                                <select class="form-control" v-model="person.province">
                                    <option v-for="province in provinces" :value="province.name">{{province.name}}</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td>Postal / Zip Code</td><td><input class="form-control" type="text" v-model="person.postal"></td>
                        </tr>
                        <tr>
                            <td>Country</td>
                            <td>
                                <select class="form-control" v-model="person.country">
                                    <option v-for="country in countries" :value="country.displayName">{{country.displayName}}</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td>Phone</td><td><input class="form-control" type="text" v-model="person.phone"></td>
                        </tr>
                        <tr v-if="!roles.includes('Recruiter') && !roles.includes('GlobalMentor')">
                            <td>Website</td><td><input class="form-control" type="url" v-model="person.website"></td>
                        </tr>
                        <tr v-if="localStorage.roles.includes('Student') || localStorage.roles.includes('CampusStudent')">
                            <td>Date Of Birth</td>
                            <td v-if="person.dateOfBirth">{{person.dateOfBirth.split('T')[0]}}</td>
                            <td v-else><input class="form-control" type="date" v-model="person.dateOfBirth"></td>

                        </tr>
                        <tr v-if="person.socialLinks && person.socialLinks.toString() !== '{}'" v-for="(value, propertyName) in person.socialLinks">
                            <td>{{propertyName}}</td>
                            <td>{{value}} <button class="remove-link" @click.prevent="deleteLink(propertyName)">x</button></td>

                        </tr>
                        <tr>
                            <td>
                                <label>Add Social Link</label>
                                <select class="form-control" v-model="socialLink.platform">
                                    <option v-for="platform in platforms" :value="platform">{{platform}}</option>
                                </select>
                            </td>
                            <td class="social-link">
                                <label>URL</label>
                                <input class="form-control" v-model="socialLink.url">
                                <button class="btn btn-success" @click="updateSocialLinks()">Add</button>
                            </td>

                        </tr>

                    </tbody>

                </table>
                <h3 v-if="roles.includes('Recruiter')">
                    Recruiter Information
                </h3>

                <table v-if="roles.includes('Recruiter')" class="table">
                    <tbody>
                        <tr>
                            <td>
                                Job Title
                            </td>
                            <td>
                                <input type="text" class="form-control" v-model="person.jobTitle" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Company
                            </td>
                            <td>
                                <input type="text" class="form-control" v-model="person.company" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Website
                            </td>
                            <td>
                                <input type="text" class="form-control" v-model="person.website" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Job Description
                            </td>
                            <td>
                                <textarea class="form-control" v-model="person.jobDescription"></textarea>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="button-wrapper">                    
                    <button class="btn btn-success" @click.prevent="updateInfo()">Update</button>
                </div>

            </div>
            <mentor-profile-editor v-if="roles.includes('Mentor') || roles.includes('GlobalMentor')" />
        </div>
    </div>
    <div class="panel">
        <div class="panel-heading">
            <h2>Change Password</h2>
        </div>

        <div class="panel-body">
            <form class="change-password">
                <div class="form-group col-xs-12">
                    <input class="form-control" type="password" v-model="newPassword.currentPassword" name="current_password" placeholder="Current Password"></input>
                </div>
                <div class="form-group col-xs-12">
                    <input class="form-control" type="password" v-model="newPassword.newPassword" name="new_password" placeholder="New Password"></input>
                </div>
                <div class="form-group col-xs-12">
                    <input class="form-control" type="password" v-model="newPassword.confirmPassword" name="confirm_new_password" placeholder="Confirm New Password"></input>
                </div>
                <button @click.prevent="changePassword()" class="btn btn-success">Change Password</button>
            </form>
        </div>
    </div>

    <div class="panel">
        <div class="panel-heading">
            Documents
        </div>
        <div class="panel-body">
            <div class="col-xs-12">
                <div v-for="document in documents" class="document-link">
                    <a href="#" @click.prevent="downloadSlip(document)">{{document.type}}</a>
                </div>
            </div>
        </div>
    </div>
    <div class="panel" v-if="roles !== ['Recruiter']">
        <div class="panel-heading"><h2>Notifications</h2></div>
        <div class="panel-body notification-settings-wrapper">
            <ul class="notification-settings clearfix">

                <li class="clearfix">
                    <div class="col-md-6">
                        Desktop Notifications
                    </div>
                    <div class="col-md-6">
                        <toggle-button v-model="showDesktopNotifications" @change="setDesktopNotifications"/>
                    </div>
                </li>
                <li class="clearfix">
                    <div class="col-md-6">
                        Email Notifications
                    </div>
                    <div class="col-md-6">
                        <toggle-button v-model="settings.getEmailNotifications" @change="setEmailNotifications"/>


                    </div>
                </li>
            </ul>

        </div>
    </div>
</section>
</template>

<script>
    import router from '../router';
    import aws from '../services/aws';
    import users from '../services/users';

    import MentorProfileEditor from './MentorProfileEditor';

    import axios from 'axios';
    import toastr from 'toastr';

    export default {
        data() {
            return {
                person: null,
                countries: [],
                provinces: [],
                documents: [],
                socialLink:{},
                platforms: ['Facebook','Instagram','LinkedIn','ArtStation','Twitter','YouTube','Vimeo'],
                newPassword: {
                    currentPassword: null,
                    newPassword: null,
                    confirmPassword: null
                },
                showDesktopNotifications: true,
                settings: {
                    getEmailNotifications: true
                },
            }
        },
        components:{
            MentorProfileEditor,
        },
        async mounted() {
            await this.getPerson();
            this.getDocuments();
            this.populateCountries();

            if (!this.roles === ['Recruiter']) {
                this.getSettings();
            }
         
            if (Notification.permission === 'granted') {
                this.showDesktopNotifications = true;
            } 
         
        },
        methods: {
            async populateCountries() {
                const countries = await axios.get('https://tto-countries.s3.us-west-2.amazonaws.com/countries.json');

                this.countries = countries.data;
                this.populateProvinces();
            },
            async populateProvinces() {
                const country = this.countries.find(c => c.displayName === this.person.country);
                if (country && country.filename) {
                    const provinces = await axios.get('https://tto-countries.s3.us-west-2.amazonaws.com/countries/'+country.filename+'.json');
                    console.log(provinces.data)
                    this.provinces = provinces.data;
                }

            },
            downloadSlip(doc) {            
                users.getDocument(doc).then((response) => {
                    console.log(response)
                });
            },
            getDocuments() {
                users.getDocuments().then((response) => {
                    this.documents = response.data;
                });
            },
            autoGrow() {
                const element = this.$refs['description'];
                element.style.height = "5px";
                element.style.height = (element.scrollHeight)+"px";
                
            },
            changePassword() {
                const newPassword = this.newPassword;
                if (!newPassword.currentPassword || !newPassword.newPassword || !newPassword.confirmPassword) {
                    toastr.error('Please fill out all fields.');
                    return;
                }
                if (newPassword.newPassword !== newPassword.confirmPassword) {
                    toastr.error('Please make sure new passwords match');
                    return;
                }

                users.changePassword(newPassword).then((response) => {
                    if (response.data.success === true) {
                        toastr.success('Password changed.');
                        this.newPassword = {currentPassword: null, newPassword:null, confirmPassword: null}
                    } else {
                        toastr.error(response.data.message);
                    }
                })
            },
            deleteLink(platform) {
                delete this.person.socialLinks[platform];
                this.$forceUpdate();
            },
            updateSocialLinks() {
                if (this.person.socialLinks === '{}') this.person.socialLinks = {};

                let socialLinks = this.person.socialLinks || {};

                if (this.socialLink.platform && this.socialLink.url) {
                    socialLinks[this.socialLink.platform] = this.socialLink.url;
                }

                this.person.socialLinks = socialLinks;
                this.socialLink = {};
                this.$forceUpdate();

            },
            setDesktopNotifications(event) {
                Notification.requestPermission();
            },
            setEmailNotifications(event) {
                var data = {
                    getEmailNotifications: event.value
                }
                users.updateSettings(this, data).then(function(response) {
                    if (response.data.success === true) {
                        toastr.success('Settings updated');
                    } else {
                        toastr.error('Error updating settings');
                    }
                });
            },
            getSettings() {
                var self = this;
                users.getSettings(this).then(function(response) {
                    console.log(response.data)
                    self.settings = response.data.settings;
                });
            },
            setAvatar() {
                var self = this;
                const uuidV4 = require('uuid/v4');
                const file = this.$refs.avatar.files[0];
                const filename = uuidV4() + '.' + file.name.split('.').pop();

                var img = new Image();
                img.onload = function () {
                 if (this.width > 800 || this.height > 800) {
                    toastr.error("Please upload an image no larger than 800 x 800 px");
                }
                else {
                    aws.signature(file, filename, 'ttto-avatars').then(function(signature) {
                        aws.upload(file, filename, signature, 'ttto-avatars').then(function(response) {
                            users.setAvatar(self, response.url).then(function(res) {
                                self.getPerson();
                            });
                        });
                    });
                }
            };

            img.src = window.URL.createObjectURL(file);

        },

        updateInfo() {
            users.selfUpdate(this, this.person).then(function(response) {
                if (response.data.success === true) {
                    toastr.success('Information updated');
                } else {
                    toasrt.error('Error updating information')
                }
            })
        },
        getPerson() {
            let id;
            if (localStorage.roles.includes('Supervisor')){
                id = localStorage.user_id;
            }
            return users.getMe(this, id).then((response) => {
            
                this.person = response.data.person;              

                if (typeof this.person.socialLinks === 'string') {
                    try {
                        this.person.socialLinks = JSON.parse(JSON.parse(this.person.socialLinks)); //gd it wordpress
                    } catch(e) {
                        this.person.socialLinks = JSON.parse(this.person.socialLinks);
                    }
                } 
                return true;
            });
        }
    },
    computed: {
        roles() {
            return JSON.parse(localStorage.getItem('roles'));
        }
    },

}

</script>


<style lang="scss" scoped>
.avatar-button + input {
    display:none;
}
.button-wrapper {
    text-align: right;
    padding-bottom: 1rem;
}
textarea {
    resize: none;
    overflow: hidden;
    min-height:100px;
    max-height: 200px;
}
h3 {
    color:#b0b0b0;
    font-weight:200;
    font-size:2.2rem;
}
.remove-link {
    background: transparent;
    border:1px solid #33ccff;
    color:#33ccff;
    margin-left:1rem;
}
.social-link {
    label {
        display:block;
        margin-top:2.5rem;
    }
    input {
        width:75%;
        float:left;
    }
    button {
        padding:.5rem 1rem;
        position: relative;
        top:-10px;
        left:1rem;
    }
}
    .panel-body {
        padding-top:20px!important;
    }
    .avatar {
        width:100%;
        margin-bottom:2rem;
    }
    .change-password {
        padding:0 1rem 2rem 1rem;
        button {
            margin-left:1rem;
        }
    }
    .notification-settings {
        li {
            padding: 2rem 0;
            border-bottom: 1px solid #363636;

        }
    }

    .notification-settings-wrapper {
        padding-top:0px!important;
    }
    table {
        table-layout: fixed;
        tr td:first-child {
            font-weight: 700;
        }
        input {
            background:transparent;
            color:#fff;
            padding:0;
            height:auto;

        }
    }

    .document-link {
        margin-bottom: 1rem;
    }
</style>



// WEBPACK FOOTER //
// Settings.vue?22f54de3